module.exports = __webpack_public_path__ + "img/redo.4cb063bf.svg";